import React, { useContext } from 'react';

import BillingContext from '@totem/components/ticketing/billing/billingContext';
import Hours from '@totem/components/ui_components/widgets/hours/hours';

const BilledUnbilledSummary = () => {
  const { totalBilled, totalUnbilled } = useContext(BillingContext);

  return (
    <div>
      <b>
        Total Hours (Billed <Hours amount={totalBilled} /> / Unbilled{' '}
        <Hours amount={totalUnbilled} />)
      </b>
    </div>
  );
};

export default BilledUnbilledSummary;
